import { SwalService } from './../../../shared/services/swal.service';
import { Router } from '@angular/router';
import { PasswordFirstTimeComponent } from './../password-first-time/password-first-time.component';
import { LoginService } from './../../services/login.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-envio-codigo',
  templateUrl: './modal-envio-codigo.component.html',
  styleUrls: ['./modal-envio-codigo.component.css', '../modalstyles.css']
})
export class ModalEnvioCodigoComponent implements OnInit {
  mailForm: FormGroup;
  codeForm: FormGroup;

  correoEnviado: boolean;
  _sent: boolean;

  setPasswordModal: BsModalRef;

  constructor(
    private formbuilder: FormBuilder,
    public modalRef: BsModalRef,
    private _login: LoginService,
    private modalService: BsModalService,
    private router: Router,
    private _swal: SwalService
  ) {}

  ngOnInit() {
    this._sent = false;
    this.correoEnviado = false;

    // this.openPasswordFirstTimeModal();

    this.initMailForm();
  }

  /**
   * Inicialización del formulario para enviar el correo donde va a llegar el código
   */
  initMailForm() {
    this.mailForm = this.formbuilder.group({
      correo: [null, [Validators.required, Validators.email]],
      primary_key: [
        sessionStorage.getItem('primary_key'),
        [Validators.required]
      ]
    });
  }

  /**
   * Inicialización del formulario para enviar el código para validar el correo
   */
  initCodeForm() {
    this.codeForm = this.formbuilder.group({
      correo: [
        sessionStorage.getItem('mail'),
        [Validators.required, Validators.email]
      ],
      codigo: [
        null,
        [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          Validators.pattern('^[0-9]*$')
        ]
      ]
    });
  }

  get f() {
    return this.codeForm.controls;
  }

  /**
   * Envío del correo en donde se va a recibir el código
   */
  envioCorreo() {
    console.log(this.mailForm.value);

    this._sent = true;

    if (this.mailForm.invalid) {
      return;
    } else {
      sessionStorage.setItem('mail', this.mailForm.controls.correo.value);

      this.initCodeForm();

      this._login.sendVerificationCode(this.mailForm.value).subscribe(
        data => {
          console.log(data);

          if (data['CorreoEnviado']) {
            this.correoEnviado = true;
            this._sent = false;
          }
        },
        error => {
          console.log(error);

          sessionStorage.removeItem('mail');

          this._swal
            .showPromiseErrorModal(
              'Ya este correo existe',
              'Si crees que se ha trata de un error, contacta a soporte.'
            )
            .then(result => {
              console.log(result);
              if (result['value']) {
                this._sent = false;
                this.mailForm.controls.correo.setValue(null);
              }
            });
        }
      );
    }
  }

  /**
   * Envío del código recibido en el correo
   */
  envioCodigo() {
    console.log(this.codeForm.value);

    if (this.codeForm.invalid) {
      return;
    } else {
      this._login.sendMailCode(this.codeForm.value).subscribe(
        data => {
          console.log(data);

          if (data['proveedorVerificado'] || data['ClienteVerificado']) {
            this.modalRef.hide();

            this._swal
              .showPromiseSuccessModal(
                'Cuenta verificada exitosamente',
                'A continuación, cambie su contraseña.'
              )
              .then(result => {
                console.log(result);
                if (result['value']) {
                  this.openPasswordFirstTimeModal();
                }
              });
          } else {
            return;
          }
        },
        error => {
          console.log(error);
          if (error['error']['ErrorCredenciales']) {
            this._swal
              .showPromiseErrorModal(
                'Código incorrecto',
                'El código que ingresaste es incorrecto, por favor intenta nuevamente.'
              )
              .then(result => {
                console.log(result);
                if (result['value']) {
                  this._sent = false;
                }
              });
          }
        }
      );
    }
  }

  hidingModal() {
    this.modalRef.hide();
    this.router.navigate(['/']);
  }

  /**
   * Modal de contraseña por primera vez
   * El modal se abrirá después de validado el correo
   */
  openPasswordFirstTimeModal() {
    this.setPasswordModal = this.modalService.show(PasswordFirstTimeComponent, {
      class: 'modal-md modal-dialog-centered animated fadeIn',
      ignoreBackdropClick: true,
      keyboard: false
    });
  }
}
